var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:['svg--' + _vm.name]},[_c('use',{attrs:{"xlink:href":_vm.static('svg/blocks.sprite.svg#' + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }